package com.patronat.top.features.usermanagement.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.domain.models.profiles.User
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.features.usermanagement.domain.repository.ProfileRepository

data class GetUserByIdCommand(val userId: String)

class GetUserByIdUseCase(
    private val profileRepository: ProfileRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetUserByIdCommand, DomainResult<User>>(dispatcherProvider.io) {
    override suspend fun doWork(command: GetUserByIdCommand): DomainResult<User> {
        return profileRepository.getUserById(command.userId)
    }
}